import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import _ from "lodash";

import * as kurentoUtils from "kurento-utils";

// components
import ShowSnapOptionsModal from "COMPONENTS/CommonComponents/NegativeActionConfirmationModal/NegativeActionConfirmationModal";
import EndSnapshotConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";
import Participants from "COMPONENTS/CommonComponents/Header/Participants/Participants";
import Canvas from "COMPONENTS/CommonComponents/Canvas/Canvas";
import Spinner from "COMPONENTS/Spinner/Spinner";
import BitRateTile from "COMPONENTS/CommonComponents/BitRate/BitRateTile";

// Assets 
import snapshot_img from "ASSETS/Images/ic_take_snapshot_button.svg";
import ic_switch_camera from "ASSETS/Images/video_menu/ic_camera_switch_white.svg";
import ic_snapshot_close from "ASSETS/Images/ic_snapshot_close.svg";

// Constants
import { socketMessage, webRtcMessageId, mediaType } from "WEBSOCKET/constants";
import {
  USER_ROLES, Modules, BANDWIDTH_MANAGEMENT_LIST, BANDWIDTH_IDX_MEDIUM, DEFAULT_FPS,
  BANDWIDTH_CUSTOM,
} from "UTILS/Constants";
import { getMediaConstraints,
  convertBlobToFile, 
  getUserMediaError,
  getTurnServerOptionConfig,
  isMobileOriPad,
  isIphone13OrHigher,
  isMobileView,
  isTabletLandscape,
  isDesktopView,
} from "UTILS/Utility";

import { isIPad13, isSafari } from 'react-device-detect'
import { CANVAS_TYPES, CANVAS_SOURCE } from "UTILS/Constants";
import { wsocket } from "WEBSOCKET/wsocket";

// String
import { getMessage } from "CONFIG/i18n";

// Styles
import "./AnnotationBar.less";
import "./Snapshot.less";

export class Snapshot extends Component {
  constructor(props) {
    super(props);
    this.currentStream = null;
    this.isAndroidMobile = /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.isIphone = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    this.isIE = /*@cc_on!@*/false || !!document.documentMode;
    this.videoStreaming = null;
  }
  state = {
    deviceList: {},
    selectedDevice: null,
    facingMode: "environment",
    streaming: false,
    showSnapOptionsPopup: false,
    showEndSnapshotConfirmationModal:false,
    showParticipant: false,
    enableCamera: false,
    videoWidth: 0,
    videoHeight: 0,
    participantsModalShow: true,
    showPreviewModal: false,
    previewFileObject: null
  };
  componentDidMount() {
   
    if (!wsocket.io) return;

    // interval used to determine if video streaming has started on IE 
    // TODO: this can also be used to hide spinner, instead of timeout of 2sec 
    if (this.isIE) {
      this.videoStreaming = setInterval(() => {
        var video = document.getElementById("snapshotvideo");
        // add snapshot canvas for IE as canPlay does not work on IE
        if(video && video.videoHeight !== this.state.videoHeight && video.videoWidth !== this.state.videoWidth)
        {
          this.setVideoDimensions()
        }
      }, 2000);
    }
    
    // #snapshot related .whiteCanvasDiv size.
    // During snapshot, if the height specification is not turned off, the layout will be broken in the iOS DesktopView.
    const whiteCanvasDiv = document.getElementsByClassName("whiteCanvasDiv");
    if (whiteCanvasDiv[0] && isDesktopView(this.props.orientation)) {
      whiteCanvasDiv[0].style.height = "";
    }

    var mediaElement = document.getElementById("snapshotvideo");
    mediaElement.oncanplay = () => {
      this.setVideoDimensions();
    }
    
    // reset video dimensions when stream resizes (orientation change)
    mediaElement.onresize = () => {
      var video = document.getElementById("snapshotvideo");
      if(video && (video.videoHeight/video.videoWidth).toFixed(2) !== 
        (this.state.videoHeight/this.state.videoWidth).toFixed(2)) {
      // if(video.videoHeight !== this.state.videoHeight ||
      //   video.videoWidth !== this.state.videoWidth) {
        this.props.showSpinner();
        this.setVideoDimensions();
      }
    }

    // if (this.props.snapshotPermissionReply !== true) {
    //   return;
    // }
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      return;
    } 
    
    let isVideoCallRunning = false;
      
    if(this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO &&
       this.props.organiser !== this.props.uniqueId){
      this.props.admittedParticipants.forEach(participant => {
        if (participant.uniqueId === this.props.snapshoteeId && !isVideoCallRunning) {
          isVideoCallRunning = participant.mediaType === mediaType.AUDIO_VIDEO
        }
      })
    }
    if(isVideoCallRunning) {
      this.props.audioVideoAction.setStopVideoCallFlag(true);
    } else if(this.props.uniqueId == this.props.snapshoteeId) {
      this.startSnapshot();
    }

    var mediaElement = document.getElementById("snapshotvideo");
    mediaElement.oncanplaythrough = () => {
      this.setVideoDimensions();
    }

    this.setSnapshotHeaderPosition();
    if((isMobileView(this.props.orientation) || isTabletLandscape(this.props.orientation))){
      window.addEventListener("resize", this.setSnapshotHeaderPosition)
    }
  }

  startSnapshot = () => {
    // In case of iphone we do not get deviceId until we accept camera request from browser.
    // so by default it start front camera stream so we stop that stream in handleSuccess fun
    if(this.isIphone || isIPad13 || isSafari) { 
      navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
        this.stopMediaTracksOfGivenStream(stream);
        this.enumerateDevices();
      })
      .catch(function(error) {
        console.error('getUserMedia() error: ', error);
      });
    } else {
      this.enumerateDevices();
    }
    if(!isMobileOriPad()) {
      navigator.mediaDevices.ondevicechange = (event) => {
        this.enumerateDevices(true);
      }
    }
  }
  
  setVideoDimensions = () => {
    var video = document.getElementById("snapshotvideo");
    if(video && video.videoHeight && video.videoWidth) {
      this.setState({
        enableCamera: true, 
        videoHeight: video.videoHeight,
        videoWidth: video.videoWidth
      })
      this.props.hideSpinner();
    }
  }

  clearSnapshotCanvas = () => {
    const message = {
      data: {
        category: socketMessage.category.WHITEBOARD,
        action: socketMessage.subCategories.WHITEBOARD.CLEAR_CANVAS,
        sessionKey: this.props.sessionKey,
        canvasId: this.props.canvasId,
        participantId: this.props.participantId,
        canvasType: CANVAS_TYPES.REGULAR,
        activePage: -1,
        canvasSource: CANVAS_SOURCE.SNAPSHOT
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  changeActiveCanvas = () => {
    let message = {};
    message = {
      data: {
        category: socketMessage.category.WHITEBOARD,
        action: socketMessage.subCategories.WHITEBOARD.CHANGE_ACTIVE_CANVAS,
        sessionKey: this.props.sessionKey,
        canvasId: this.props.whiteboardActiveCanvas.canvasId,
        canvasType: this.props.whiteboardActiveCanvas.canvasType,
        activePage: -1
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  enumerateDevices = (onDeviceChange = false) => {
    if (this.props.uniqueId === this.props.snapshoteeId) {
      if(isMobileOriPad() && this.state.facingMode) {
        // (Iphone Mobile): Change facingMode only once if faceingMode is null
        // this.setState({
        //   facingMode: this.state.facingMode && this.state.facingMode == 'environment' ? 'user' : 'environment'
        // }, () => {
        this.displayCameraStream();
        //});
      } else if(!isMobileOriPad()){
        //in desktop case execute this every time if device changes and first time to get device list
        navigator.mediaDevices.enumerateDevices().then(devices => {
          // this.props.showSpinner();
          //get camera list
          let deviceList = devices.filter(device => device.kind === "videoinput");
          this.setState({
            deviceList: deviceList
          });
          let currentDeviceId = this.state.selectedDevice && this.state.selectedDevice.deviceId;
          let isCurrentlyStreamingDeviceInNewDeviceList = devices.filter(device => device.deviceId === currentDeviceId).length > 0;
          // onDeviceChange, if same device is being used for streaming, just hode spinner and return
          if(onDeviceChange && isCurrentlyStreamingDeviceInNewDeviceList) {
            this.props.hideSpinner();
            return;
          }
          let deviceToBeSelected = deviceList[0];
          if(deviceToBeSelected && currentDeviceId !== deviceToBeSelected.deviceId) {
            this.setState({
              selectedDevice:deviceToBeSelected,  //we are selecting back camera by deafult if it is mobile
            }, () => {
              this.displayCameraStream();
            });
          } else {
            // When there is only one webcam connected and we reconnect that webcam 
            // selectedDevice value is not set to null 
            // due to which stream does not start again 
            // Reason: deviceToBeSelected is undefined
            if(!deviceToBeSelected && onDeviceChange) {
              this.setState({
                selectedDevice: null
              })
            }
            this.props.hideSpinner();
          }
        });
      }
    }
  }

  displayCameraStream = () => {
    // if user_role == user
    if (this.props.uniqueId === this.props.snapshoteeId) {
      //if (this.state.selectedDevice !== null || this.state.facingMode !== null) {

      const videoBandwidthSettings = {
        module: this.props.videoBandwidthSettings.module,
        bandwidth: BANDWIDTH_MANAGEMENT_LIST[BANDWIDTH_IDX_MEDIUM].value,
        fps: DEFAULT_FPS,
      }
      let videoConstraints = getMediaConstraints({
        media: mediaType.VIDEO,
        videoBandwidthSettings: videoBandwidthSettings,
        isSnapshot: true
      });

      if(!isMobileOriPad() && this.state.selectedDevice && this.state.selectedDevice.deviceId) {
        videoConstraints.video.deviceId = this.state.selectedDevice.deviceId;
      }
      if(isMobileOriPad() && this.state.facingMode) {
        videoConstraints.video.facingMode = { exact: this.state.facingMode };
      }
      this.stopMediaTracksOfGivenStream(this.currentStream);
      navigator.mediaDevices.getUserMedia(videoConstraints)
      .then(stream => this.generateLocalSnapShotVideo(stream))
      .catch((error) => {
        let errorMessage = getUserMediaError(error, mediaType.VIDEO)
        if(errorMessage){
          toastr.error(getMessage(errorMessage))
          this.props.hideSpinner(true);
          if(errorMessage === "CAMERA_BUSY")
            this.handleRemove(true, true);
          else if(errorMessage === "CAMERA_PERMISSION")
            this.handleRemove(false);// false parameter is for user block camera permission
          
          return;
        } else{
          if(!isMobileOriPad() && this.deviceList && this.deviceList.length > 1) {
            this.switchCamera();
          }
          else {
            this.props.hideSpinner(true);
          }
        }          
      });
      //}
    }
  }

  componentWillUnmount() {

    this.props.headerAction.updateHeaderIconClass(Modules.SNAPSHOT, "moduleIcon", " cursorPointer");
    if (this.props.uniqueId === this.props.snapshoteeId) {
      this.stopMediaTracksOfGivenStream(this.currentStream);//we are stopping stream on component unmount
    }
    if(this.videoStreaming) 
      clearInterval(this.videoStreaming);

    this.setCanvasDivHeight();
    if((isMobileView(this.props.orientation) || isTabletLandscape(this.props.orientation))){
      window.removeEventListener("resize", this.setSnapshotHeaderPosition)
    }
  }

  componentDidUpdate(prevProps) {

    // usecase: switch camrea on IE.
    if(this.props.isPeerDisposed) {
      // if user
      if (this.props.uniqueId == this.props.snapshoteeId) {
        this.displayCameraStream();
      } else {  // if agent 
        if(!this.isIE)
          this.props.showSpinner();
        this.generateRemoteSnapShotVideo();
      }
      this.props.sessionActions.setPeerDisposed(false);
    }
    // if (
    //   this.props.snapshotPermissionReply !==
    //   prevProps.snapshotPermissionReply &&
    //   this.props.snapshotPermissionReply === true
    // ) {
    //   var mediaElement = document.getElementById("snapshotvideo");
    //   mediaElement.style.display = "block"
    //   setTimeout(() => {
    //     if (this.props.uniqueId !== this.props.snapshoteeId) {
    //       this.generateRemoteSnapShotVideo();
    //     }
    //   }, 200);
    // }
    if (
      this.props.snapshotPermissionReply !==
      prevProps.snapshotPermissionReply &&
      this.props.snapshotPermissionReply !== true
    ) {
      var mediaElement = document.getElementById("snapshotvideo");
      mediaElement.style.display = "none"
      this.props.sessionActions.updateSnapshotPermissionReply(null);
      this.props.sessionActions.updateSnapshotPermissionStatus({});
      this.props.snapShotModelClose();
      
    }
    if(this.props.createSnapshotRtcPeer !== prevProps.createSnapshotRtcPeer && 
      this.props.createSnapshotRtcPeer && 
      this.props.snapshoteeId === this.props.uniqueId && this.currentStream){
      /*  create user side rtc peer after we get _SNAPSHOT_PERMISSION_REPLY */
      this.createRtcPeer(this.currentStream);
    }
    if(this.props.createSnapshotRtcPeer !== prevProps.createSnapshotRtcPeer && 
      this.props.createSnapshotRtcPeer && 
      this.props.organiser === this.props.uniqueId){
      /*  create agent side (remote) rtc peer after we get _SNAPSHOT_PERMISSION_REPLY */
      if(!this.props.isGuestTakesSS) {
        var mediaElement = document.getElementById("snapshotvideo");
        mediaElement.style.display = "block"
      }
      setTimeout(() => {
        if (this.props.uniqueId !== this.props.snapshoteeId) {
          this.generateRemoteSnapShotVideo();
        }
      }, 200);
    }
    if (prevProps.admittedParticipants && !_.isEqual(this.props.admittedParticipants.length, prevProps.admittedParticipants.length) && !this.state.showParticipant) {
      this.setState({showParticipant: true});
    }
    if(this.props.isLandscape !== prevProps.isLandscape && 
        this.props.isMobileSafari && !isIphone13OrHigher() && !isIPad13 &&
        (prevProps.isLandscape !== null && this.props.isLandscape !== null) &&
        this.props.createSnapshotRtcPeer
    ){
      const { sessionKey } = this.props;
      //In case of IPhone iOS12 (not for iOS13) on orientation change stream get paused, so we are desposing stream and starting again.
      const message = {
        data: {
          category: socketMessage.category.WEBRTC,
          action: webRtcMessageId.SWITCH_SNAPSHOT_CAMERA,
          sessionKey: sessionKey,
          snapshoterId: this.props.snapshoter
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
      this.props.showSpinner();
      // this.displayCameraStream();
    }

    if(this.props.startSnapshot && 
      this.props.startSnapshot !== prevProps.startSnapshot && 
      this.props.uniqueId === this.props.snapshoteeId){
      this.startSnapshot();
    }
    // stop snapshot window on resetting startSnapshot flag especially when KMS is down in between and _RELEASE_ALL_REMOTE_MEDIA ws call is received
    if(this.props.startSnapshot != prevProps.startSnapshot 
      && !this.props.startSnapshot) {
      this.props.snapShotModelClose();
    }
    if(prevProps.isHideBar !== this.props.isHideBar){
      this.setSnapshotHeaderPosition();
    }
  }

  // gets called at Agent end
  generateRemoteSnapShotVideo() {
    var mediaElement = document.getElementById("snapshotvideo");
    let self = this;
    mediaElement && mediaElement.addEventListener(
      "canplay",
      ev => {
        if (!this.state.streaming) {
          this.setVideoDimensions();
          this.setState({
            streaming: true
          });
          let snapshot = document.getElementById("snapshot");
          isMobileOriPad() && snapshot && snapshot.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
        }
      },
      false
    );
    const videoBandwidthSettings = _.cloneDeep(this.props.videoBandwidthSettings);
    if (this.props.videoBandwidthSettings.bandwidth === BANDWIDTH_CUSTOM) {
      videoBandwidthSettings.bandwidth = this.props.videoCustomBandwidthSettings.size;
    }
    let options = {
      remoteVideo: mediaElement,
      mediaConstraints: getMediaConstraints({
        media: mediaType.VIDEO,
        videoBandwidthSettings,
      }),
      onicecandidate: this.onIceCandidate,
      configuration: {
        iceServers: getTurnServerOptionConfig(this.props.turnServer),
        iceTransportPolicy: window._env_.REACT_APP_ICE_TRANSPORT_POLICY || 'all'
      }
    };
    if (wsocket.snapshotRtcPeer === null) {
      wsocket.snapshotRtcPeer = new kurentoUtils.WebRtcPeer.WebRtcPeerRecvonly(
        options,
        function (error) {
          if (error) {
            
            return console.error(error);
          }
          this.generateOffer(self.offerToReceiveVideo);
          self.setState({
            showBitrate: true
          })
        }
      );
    } else {
      if (this.isIE) {
        attachMediaStream(
          mediaElement,
          wsocket.snapshotRtcPeer.getRemoteStream()
        );
      } else {
        mediaElement.srcObject = wsocket.snapshotRtcPeer.getRemoteStream();
      }
      
      mediaElement.play();
    }
  }

  stopMediaTracksOfGivenStream = (stream) => {
    stream && stream.getTracks().forEach(track => {
      track.stop();
    });
    this.currentStream = null;
    let snapshotvideoElement = document.getElementById("snapshotvideo");
    if(snapshotvideoElement){
      snapshotvideoElement.srcObject = null;
    }
  }

  createRtcPeer = stream => {
    let self = this;
    const videoBandwidthSettings = _.cloneDeep(this.props.videoBandwidthSettings);
    if (this.props.videoBandwidthSettings.bandwidth === BANDWIDTH_CUSTOM) {
      videoBandwidthSettings.bandwidth = this.props.videoCustomBandwidthSettings.size;
    }
    let options = {
      videoStream: stream,
      mediaConstraints: getMediaConstraints({
        media: mediaType.VIDEO,
        videoBandwidthSettings,
      }),
      onicecandidate: this.onIceCandidate,
      configuration: {
        iceServers: getTurnServerOptionConfig(this.props.turnServer),
        iceTransportPolicy: window._env_.REACT_APP_ICE_TRANSPORT_POLICY || 'all'
      }
    };
    wsocket.snapshotRtcPeer = new kurentoUtils.WebRtcPeer.WebRtcPeerSendonly(
      options,
      function (error) {
        if (error) {
          return console.error("Error in kurentoUtils.WebRtcPeer.WebRtcPeerSendonly:", error);
        }
        this.generateOffer(self.offerToReceiveVideo);
        self.setState({
          showBitrate: true
        })
      }
    );
  }

  // gets called user end
  generateLocalSnapShotVideo = stream => {
    this.currentStream = stream;
    var mediaElement = document.getElementById("snapshotvideo");
    let self = this;

    if(this.isIE) {
      attachMediaStream(mediaElement, stream);
      const { sessionKey } = this.props;
      //In case of IE replaceTrack method does not work , so we are handeling it by recreating peers.
      const message = {
        data: {
          category: socketMessage.category.WEBRTC,
          action: webRtcMessageId.SNAPSHOT_TAKEN,
          sessionKey: sessionKey,
          snapshoterId: this.props.snapshoterId
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);

      setTimeout(() => {
        this.props.hideSpinner()
        this.setState({enableCamera: true})
      }, 2000);

    } else {
      mediaElement.srcObject = stream;
    }

    // let rtcPeerConnection = participants[name].rtcPeer.peerConnection;
    if(!this.props.createSnapshotRtcPeer){
      /* if we didn't get _SNAPSHOT_PERMISSION_REPLY here then we'll create rtc peer later.
      after we get _SNAPSHOT_PERMISSION_REPLY we set `this.props.createSnapshotRtcPeer` as true
      then in componentDidUpdate we call createRtcPeer() function with this.currentStream to create create RtcPeer      
      */
      return;
    }
    if (wsocket.snapshotRtcPeer === null) {
      this.createRtcPeer(stream)
    
    } else {
      
      let videoTrack = stream.getVideoTracks()[0];
      // snapshotRtcPeer.peerConnection.getSenders() not supported in IE
      let sender = wsocket.snapshotRtcPeer.peerConnection.getSenders().find(function (s) {
        return s.track.kind == videoTrack.kind;
      });
      sender.replaceTrack(videoTrack)
      .catch((error)=>{
        console.log("Error while replaceTrack: ", error);
        //this done if replaceTrack fails when there is resolution difference between two devices
        const { sessionKey } = this.props;
        const message = {
          data: {
            category: socketMessage.category.WEBRTC,
            action: webRtcMessageId.SWITCH_SNAPSHOT_CAMERA,
            sessionKey: sessionKey,
            snapshoterId: this.props.snapshoter
          }
        };
        this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
        this.props.showSpinner();
      });
      mediaElement.play();
    }
    if (!this.state.streaming) {
      this.setState({
        streaming: true
      });
    }
  };

  onIceCandidate = (candidate, wp) => {
    let message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.ICE_CANDIDATE,
        sessionKey: this.props.sessionKey,
        iceData: {
          candidate: candidate,
          senderId: this.props.snapshoteeId,
          media: mediaType.VIDEO
        },
        isSnapshot: true
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  offerToReceiveVideo = (error, offerSdp, wp) => {
    if (error) return console.error("sdp offer error");
    var message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.SDP_OFFER,
        sessionKey: this.props.sessionKey,
        sdp: offerSdp,
        senderId: this.props.snapshoteeId,
        media: mediaType.VIDEO,
        isSnapshot: true
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  sendTakeSnapshotMessage = snapshoteeId => {
    if (this.props.customerCoBrowseStarted) {
      toastr.error(getMessage("MODULE_CANNOT_USE_WITH",
        {
          usingCaption: getMessage("CO_BROWSE"), 
          actionCaption: getMessage("SNAP_SHOT"),
        }),
      { toastId: "MODULE_CANNOT_USE_WITH" });
      return;
    }
    //if (!this.checkKMSStatus()) return;
    const { sessionKey } = this.props;
    const message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.SNAPSHOT_PERMISSION_REQUEST,
        sessionKey: sessionKey,
        snapshoteeId: snapshoteeId,
        token: this.props.token
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    this.props.sessionActions.updateSnapshoteeId(snapshoteeId);
    this.props.sessionActions.updateSnapshotPermissionReply(null);
  };

  handleRemove = (isCameraPermissionGranted=true, isCameraBusy=false) => {
    //isCameraPermissionGranted is use to send permission related flag to Agent
    if (this.props.snapshoteeId) {
      this.snapshotTakenMessage(false, isCameraPermissionGranted, isCameraBusy);
    }
    // clear snapshotee id and snapshotPermissionReply
    this.props.sessionActions.updateSnapshoteeId(null);
    this.props.sessionActions.updateSnapshotPermissionReply(null);
    this.props.snapShotModelClose();
  };

  snapshotParticipant = () => {
    let participantArray = this.props.admittedParticipants.filter(function (obj) {
      return obj.role !== USER_ROLES.AGENT;
    });
    return participantArray;
  };

  showOptionsPopup = () => {
    if (this.state.showSnapOptionsPopup === false) {
      this.setState({
        showSnapOptionsPopup: true
      })
    }
  }
  closeSnapOptionsModal = () => {
    this.setState({
      showSnapOptionsPopup: false
    })
  }
  showParticipantModal = () => {
    this.setState({
      participantsModalShow: true
    })
  }
  closeParticipantModal = () => {
    this.setState({
      participantsModalShow: false
    })
    this.setVideoDimensions()
  }

  downloadSnap = () => {
    this.props.showSpinner();
    this.setState({
      showSnapOptionsPopup: false
    })
    var video = document.getElementById("snapshotvideo");
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    // Ratio of the video's intrisic dimensions
    var videoRatio = video && video.videoWidth / video.videoHeight;
    // The width and height of the video element
    var width = video && video.offsetWidth, height = video.offsetHeight;
    // The ratio of the element's width to its height
    var elementRatio = width / height;
    // If the video element is short and wide
    if (elementRatio > videoRatio) width = height * videoRatio;
    // It must be tall and thin, or exactly equal to the original ratio
    else height = width / videoRatio;
    canvas.height = height;
    canvas.width = width;
    // canvas.height = video.clientHeight;
    // canvas.width = video.clientWidth;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    let url = canvas.toDataURL("Image/jpeg");
    let downloadElement = document.getElementById("snapDownload");
    downloadElement.href = url;
    downloadElement.download = "snap.jpeg";
    this.props.hideSpinner();

  }

  takepicture = () => {
    this.props.showSpinner();
    this.setState({
      showSnapOptionsPopup: false
    })
    var video = document.getElementById("snapshotvideo");
    var canvas = document.createElement("canvas");
    var snapshotCanvas = document.getElementById("snapshotCanvas");
    var context = canvas.getContext("2d");
    // Ratio of the video's intrisic dimensions
    var videoRatio = video && video.videoWidth / video.videoHeight;
    // The width and height set 720p size
    var width = videoRatio >= 1 ? 1280 : 720
    var height = width / videoRatio;
    canvas.height = height;
    canvas.width = width;

    const addImageToCanvas = () => {
      this.setState({showPreviewModal: true})
      canvas.toBlob(blob => {
        let fileObject = convertBlobToFile(blob, "image/jpeg", "canvas.png");
        this.setState({previewFileObject: fileObject})
        if(this.props.isGuestTakesSS){
          const PreviewImg = document.getElementById("snapshotPreviewImg");
          PreviewImg.src = window.URL.createObjectURL(fileObject);
        } else {
          this.sendSnapshot();
        }
      });
    };

    if (
      typeof AdapterJS !== "undefined" &&
      AdapterJS.webrtcDetectedBrowser === "IE" &&
      AdapterJS.webrtcDetectedVersion >= 9
    ) {
      /* video element is replaced by plugin object
      http://support.temasys.com.sg/support/solutions/articles/12000053612-how-can-i-use-drawimage-to-draw-onto-a-canvas-with-the-plugin */
      const lastFrame = video.getFrame();
      const image = new Image();
      image.onload = () => {
        try {
          context.drawImage(image, 0, 0, canvas.width, canvas.height);
          addImageToCanvas();
        } catch (error) {
          this.props.hideSpinner();
          console.error('error: ', error.message);
          return;
        }
      };
      image.onerror = () => {
        this.props.hideSpinner();
      };
      image.setAttribute("src", "data:image/png;base64," + lastFrame);
    } else {
      try {
        if (!video.paused && !video.ended) {
          context.drawImage(video, 0, 0, canvas.width, canvas.height);
          addImageToCanvas();
        }
      } catch (error) {
        this.props.hideSpinner();
        console.error('error: ', error.message);
        return;
      }
      this.props.hideSpinner();
    };
  };

  closePreviewModal = () => {
    this.setState({
      showPreviewModal: false,
      previewFileObject: null
    })
  }

  sendSnapshot = () => {
    this.snapshotTakenMessage(true);
    this.clearSnapshotCanvas();
    const fileObject = this.state.previewFileObject
    this.props.uploadFile(fileObject).then(fileUrl => {
      if (fileUrl) {
        this.props.addCanvas(CANVAS_TYPES.IMAGE, () => {

          // Tell user that photo taken and close
          this.props.snapShotModelClose();
        });
      } else {
        this.props.hideSpinner();
        // Tell user that photo taken and close
        this.props.snapShotModelClose();
      }
    });

    this.props.sessionActions.updateSnapshoteeId(null);
    this.props.sessionActions.updateSnapshotPermissionReply(null);
    this.closePreviewModal();
  }
  snapshotTakenMessage = (flag, isCameraPermissionGranted=true, isCameraBusy=false) => {
    const { sessionKey } = this.props;
    const message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.SNAPSHOT_TAKEN,
        sessionKey: sessionKey,
        snapshoteeId: this.props.snapshoteeId,
        isSnapshotTaken: flag,
        isCameraPermissionGranted:isCameraPermissionGranted, // send camera permission flag to agent
        isCameraBusy:isCameraBusy// if camera stream is used by other browsers
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };
  onOpenCloseEndSnapshotConfirmationModal = (modalState) => {
    this.setState({
      showEndSnapshotConfirmationModal: modalState
    })
    // this.props.sessionActions.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
  }
  
  showCloseButton = () => {
    return (<Button
      className="borderBtn closeCamera mr-1"
      id="close"
      onClick={()=>this.onOpenCloseEndSnapshotConfirmationModal(true)}
    >
      {getMessage("CANCEL")}
    </Button>)
  }

  switchCamera = () => {
    
    this.props.showSpinner();
    this.setState({enableCamera: false})

    if(isMobileOriPad()) {
      this.setState({
        facingMode: this.state.facingMode == 'environment' ? 'user' : 'environment'
      }, () => {
        this.displayCameraStream();
      });
    } else {
      let currentIndex = this.state.deviceList.findIndex(device => device.deviceId == this.state.selectedDevice.deviceId);
      currentIndex = currentIndex == this.state.deviceList.length - 1 ? 0 : currentIndex + 1;
      this.setState({
        selectedDevice: this.state.deviceList[currentIndex]
      }, () => {
        if (this.isIE) {
          const { sessionKey } = this.props;
          //In case of IE replaceTrack method does not work , so we send SWITCH_SNAPSHOT_CAMERA ws call to server.
          // On receiving _SWITCH_SNAPSHOT_CAMERA, we dispose the rtcpeer
          const message = {
            data: {
              category: socketMessage.category.WEBRTC,
              action: webRtcMessageId.SWITCH_SNAPSHOT_CAMERA,
              sessionKey: sessionKey,
              snapshoterId: this.props.snapshoter
            }
          };
          this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
        } else {
          this.displayCameraStream();
        }
      });
    }
  }
  setSnapshotHeaderPosition = () => {
    const mobileBottomAreaToggleBtn = document.getElementById("mobileBottomAreaToggleBtn");
    const mobileBottomArea = document.getElementById("mobileBottomArea");
    const snapshotHeader = document.getElementById("snapshotHeader");
    const padding = 8;

    if (mobileBottomAreaToggleBtn !== null && mobileBottomArea !== null && snapshotHeader !== null && isMobileView(this.props.orientation)) {
      let position = mobileBottomAreaToggleBtn.offsetHeight + 12 * 3; // 12 is "bottom" value of .mobileBottomAreaToggleBtn
      if (!this.props.isHideBar) {
        position = mobileBottomArea.offsetHeight;
      }
      snapshotHeader.style.bottom = position + padding + "px";
    } else {
      snapshotHeader.style.bottom = "";
    }
  }

  setCanvasDivHeight = () => {
    const whiteCanvasDiv = document.getElementsByClassName("whiteCanvasDiv");
    const header = document.getElementById("commonHeader");
    const canvasHeader = document.getElementsByClassName("canvasHeader");
    const padding = 8;

    if (header && whiteCanvasDiv[0] && isDesktopView(this.props.orientation)) {
      whiteCanvasDiv[0].style.height = window.innerHeight - header.clientHeight - canvasHeader[0].clientHeight - padding + "px";
    }
  }

  render() {
    var takePictureFlag = true;
    if (this.isIE) {
      if (!(this.props.snapshotPermissionReply !== true)) takePictureFlag = false;
    } else {
      if (!(this.props.snapshotPermissionReply !== true) && this.state.streaming) {
        takePictureFlag = false;
      }
    }
    let showGuestVideoFlag = false;
    if(!this.props.isGuestTakesSS || (this.props.isGuestTakesSS && this.props.organiser !== this.props.uniqueId)){
      if(this.props.snapshotPermissionReply){
        showGuestVideoFlag = true;
      }
    }
    let snapshoteeUseName = null;
    if (this.props.admittedParticipants && this.props.snapshoteeId && !this.state.showParticipant && !showGuestVideoFlag ) {
      const snapshoteeParticipant = this.snapshotParticipant().filter(participant => participant.uniqueId === this.props.snapshoteeId)
      snapshoteeUseName = snapshoteeParticipant[0] ? snapshoteeParticipant[0].userName : null;
    }
    return (
      <div
        id="snapshot"
        className={
          this.props.organiser ===
            this.props.uniqueId /*this.props.userRole === USER_ROLES.AGENT*/
            ? "positioningSnapshot positioningSnapshotAgent"
            : "positioningSnapshot positioningSnapshotUser"
        }
      >
        { this.state.showEndSnapshotConfirmationModal ? (
          <EndSnapshotConfirmationModal
            show={true}
            isDoubleButton={true}
            handleNoClick={() => { this.onOpenCloseEndSnapshotConfirmationModal(false) }}
            handleYesClick={() => {
              this.handleRemove();
            }}
            message={getMessage("END_SNAPSHOT_CONFIRMATION_TEXT")}
          /> 
        ): null}
        <div className="snapshotBody">
          <div className="snapshotHeader p-1" id="snapshotHeader">
            <div className="displayInlineFlex p-1">
              {this.showCloseButton()}
              {(this.props.isGuestTakesSS && this.props.organiser !== this.props.uniqueId) || 
                (!this.props.isGuestTakesSS && this.props.organiser === this.props.uniqueId) ? (
                  <Button
                    className="customBtn cursorPointer mr-1"
                    id="capture"
                    onClick={() =>{
                      this.takepicture();
                    } 
                    }
                    disabled={takePictureFlag}
                  >
                    {getMessage("TAKE_SNAPSHOT")}
                  </Button>
                )
                : null
              }
              {
                this.props.organiser !== this.props.uniqueId ? (
                  <Button
                    className={!(this.state.enableCamera && this.state.deviceList.length > 1 || isMobileOriPad()) ? "customBtn cursorDisabled switchCamera ml-1" : "customBtn cursorPointer switchCamera ml-1"}
                    id="capture"
                    onClick={()=>this.switchCamera()}
                    disabled={!(this.state.enableCamera && (this.state.deviceList.length > 1 || isMobileOriPad()))} /*disable switch button if only one / no camera is connected */
                  >
                    <img
                      src={ic_switch_camera}
                      alt="switchCameraIcon"
                      title={getMessage("TOOLTIP_SWITCH_CAMERA")}
                      className="img-fluid switchCameraIcon"
                    />
                  </Button>
                ): null
              }
            </div>
          </div>
          {this.state.showSnapOptionsPopup ?
            <ShowSnapOptionsModal
              confirmationText={getMessage("SELECT_AN_OPTION")}
              noButtonText={getMessage("DOWNLOAD")}
              yesButtonText={getMessage("SHOW_ON_CANVAS")}
              handleNoClick={this.downloadSnap}
              handleYesClick={this.takepicture}
              handleCrossClick={this.closeSnapOptionsModal}
              showCancelAsPrimary={true}
              showCrossIcon={true}
            />
            : null}
          <div className="camera">   
            {window._env_.REACT_APP_SHOW_BITRATE == "true" &&
            !this.isIE &&
            this.state.showBitrate &&
              <BitRateTile 
                module={Modules.SNAPSHOT}
                mediaType = {mediaType.VIDEO}
                participantUniqueID = {this.props.snapshoteeId}
                uniqueId = {this.props.uniqueId}
                wsocketPeer = {wsocket.snapshotRtcPeer}
                hide={true}
              />
            }
            <video
              id="snapshotvideo"
              style={{ display: showGuestVideoFlag ? "block" : "none"}}
              className={(this.props.uniqueId === this.props.snapshoteeId && 
                (this.state.facingMode === null || this.state.facingMode === 'user')) ? "flipVideo snapshotVideoDimensions" : "snapshotVideoDimensions"}
              autoPlay
              muted
              playsInline
            />
            <div style={{ display: showGuestVideoFlag ? "none" : "flex"}}
              className="text">
              {this.props.admittedParticipants && !this.props.snapshoteeId && (this.state.showParticipant || this.props.admittedParticipants.length > 2) ? 
                getMessage("SELECT_PARTICIPANT_TO_TAKE_SNAPSHOT") : null}
              {this.props.admittedParticipants && this.props.snapshoteeId && !this.state.showParticipant && !showGuestVideoFlag && snapshoteeUseName
                ? getMessage("WAITING_SNAPSHOT_TAKING",{ userName: snapshoteeUseName })
                : null
              }

            </div>
            {this.state.videoHeight && this.state.videoWidth && this.props.canvasId
              ? 
              <Canvas 
                canvasName="snapshotCanvas" 
                canvasId={this.props.canvasId}
                height={this.state.videoHeight} 
                width={this.state.videoWidth} 
                canvasSource={CANVAS_SOURCE.SNAPSHOT}
                sessionKey={this.props.sessionKey}
                participantId={this.props.participantId}
                sendWebsocketMessage={this.props.sendWebsocketMessage}
                canvasData={this.props.canvasData}
                lastDrawnObject={this.props.lastDrawnObject}
                ownerOfLastAction={this.props.ownerOfLastAction}
                rotateY180={(this.props.uniqueId === this.props.snapshoteeId && 
                  ((this.state.facingMode === null || this.state.facingMode === 'user') && !this.isIE))
                  ? true 
                  : false}
                showSpinner={this.props.showSpinner}
                hideSpinner={this.props.hideSpinner}
                inkColor={this.props.inkColor}
              />
              : null
            }
            {this.props.isGuestTakesSS && this.props.organiser !== this.props.uniqueId ?
              (
                <Modal className="snapshotSendConfirmModal" isOpen={this.state.showPreviewModal} backdrop="static">
                  <ModalHeader className="popupHeader text-center">
                    {getMessage("CONFIRM_SEND_SNAPSHOT")}
                  </ModalHeader>
                  <ModalBody>
                    <img id="snapshotPreviewImg" />
                  </ModalBody>
                  <ModalFooter className="permissionButtons">
                    <Button
                      className="buttons btn-decline"
                      onClick={this.closePreviewModal}
                    >
                      {getMessage("RETAKE_SNAPSHOT")}
                    </Button>
                    <Button
                      className="buttons btn-accept customBtn"
                      onClick={this.sendSnapshot}
                    >
                      { getMessage("SEND")}
                    </Button>
                  </ModalFooter>
                </Modal>
              ) : 
              null
            }
          </div>
          { this.props.organiser === this.props.uniqueId && 
            this.props.admittedParticipants.length > 2 ? (
              <Participants
                userRole={this.props.userRole}
                participants={this.snapshotParticipant()}
                mobileView={true}
                isSnapshot={true}
                sendTakeSnapshotMessage={this.sendTakeSnapshotMessage}
                snapshoteeId={this.props.snapshoteeId}
                uniqueId={this.props.uniqueId}
                organiser={this.props.organiser}
                showParticipant={this.state.showParticipant || this.props.admittedParticipants.length > 2}
                show={this.state.participantsModalShow}
                handleCancelClick={() => this.handleRemove()}
                handleStartClick={() => this.closeParticipantModal()}
                language={this.props.language}
              />
            ) : 
            null
          }
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    isPeerDisposed: state.SessionReducer.isPeerDisposed,
    participantId: state.SessionReducer.participantId,
    canvasId: state.SnapshotReducer.snapshotCanvas && state.SnapshotReducer.snapshotCanvas.canvasId,
    canvasData: state.SnapshotReducer.snapshotCanvasData,
    lastDrawnObject: state.SnapshotReducer.lastDrawnObject,
    ownerOfLastAction: state.SnapshotReducer.ownerOfLastAction,
    whiteboardActiveCanvas: state.WhiteboardReducer.activeCanvas,
    inkColor: state.WhiteboardReducer.defaultFontInfo.fontColor
  }
}
const mapDispatchToProps = dispatch => {
  return bindActionCreators({},
    dispatch
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Snapshot);
